<template>
<li class="main-menu__item" :class="menuHasSub">
    <slot></slot>
</li>
</template>

<script>
export default {
    props: {
        menu: {
            type: Object,
            required: true
        }
    },
    computed: {
        menuHasSub() {
            return (this.menu.hassubmenu === 'Y' || this.menu.pgm === "load_langs")? 'main-menu__item--submenu--menu main-menu__item--has-submenu' : '';
        }
    }
}
</script>

